import { normalizeBrazilianE164 } from "./phone";

/**
 * Link de WhatsApp a partir do contato que o estabelecimento cadastrou
 * (CAD-29). O valor é livre no cadastro e dado legado continua publicado, então
 * nunca vai literal para um `href`: só sai link para
 * - telefone (dígitos, espaço, `+`, `(`, `)`, `-`, `.`), montado como
 *   `https://wa.me/<dígitos>`;
 * - URL `https://wa.me/...` ou `https://api.whatsapp.com/...`, sem usuário,
 *   senha nem porta.
 * Qualquer outra coisa (`javascript:`, texto livre, outro site) devolve null e
 * quem renderiza não mostra o link.
 */

const WHATSAPP_HOSTS = new Set(["wa.me", "api.whatsapp.com"]);
const PHONE_SHAPE = /^\+?[\d\s().-]+$/;
const SCHEMELESS_WHATSAPP = /^(wa\.me|api\.whatsapp\.com)\//i;

function whatsappUrl(value: string): string | null {
  const candidate = SCHEMELESS_WHATSAPP.test(value) ? `https://${value}` : value;
  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    return null;
  }
  if (url.protocol !== "https:") return null;
  if (!WHATSAPP_HOSTS.has(url.hostname)) return null;
  if (url.username || url.password || url.port) return null;
  return url.href;
}

export function buildEstablishmentWhatsappHref(
  value: string | null | undefined
): string | null {
  const raw = String(value ?? "").trim();
  if (!raw) return null;

  if (PHONE_SHAPE.test(raw)) {
    const e164 = normalizeBrazilianE164(raw);
    return e164 ? `https://wa.me/${e164.slice(1)}` : null;
  }

  return whatsappUrl(raw);
}
